import { updateGuestPhone } from "@/api/register";
import type { UserInformation } from "@/api/signin";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type UpdateGuestPhoneArgs = {
	guestId: number;
	phone: string;
	phone_global_country_id: number;
	global_country_id: number;
};

export default function useUpdateGuestPhone(
	options?: MutationOptionsWithoutFn<UserInformation, UpdateGuestPhoneArgs>,
) {
	return useMutation({
		mutationFn: ({
			guestId,
			phone,
			phone_global_country_id,
			global_country_id,
		}: UpdateGuestPhoneArgs) =>
			updateGuestPhone(guestId, {
				phone,
				phone_global_country_id,
				global_country_id,
			}),
		...options,
	});
}
